import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';

import { RouteSegment } from '@core/enums/route-segment.enum';

import { PermissionStoreModelEnum } from '@domain/permissions/permissions.enums';

import { SiteAtAGlanceComponent } from '@shared/components/site-at-a-glance';
import { SiteAtAGlanceLoadingSkeletonComponent } from '@shared/components/site-at-a-glance-loading-skeleton';
import { SiteAtAGlanceViewModel } from '@shared/components/site-at-a-glance/site-at-a-glance.view-model';
import { TableViewLinkComponent } from '@shared/components/table-view-link';
import { HasPermissionPipe } from '@shared/pipes/has-permission/has-permission.pipe';

import { AtAGlanceSiteCardViewModel } from './at-a-glance-site-card.view-model';

@Component({
  selector: 'app-at-a-glance-site-card',
  imports: [
    TableViewLinkComponent,
    RouterLink,
    SiteAtAGlanceComponent,
    SiteAtAGlanceLoadingSkeletonComponent,
    HasPermissionPipe,
    TranslatePipe,
  ],
  templateUrl: './at-a-glance-site-card.component.html',
  host: {
    class: 'flex flex-col gap-2 bg-background-fixed rounded-radius-primary pt-[10px] pb-[14px] px-4',
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AtAGlanceSiteCardComponent {
  public readonly vm = input.required<AtAGlanceSiteCardViewModel>();
  public readonly atAGlanceVm = computed<SiteAtAGlanceViewModel>(() => ({
    vehiclesPerState: this.vm().vehiclesPerState,
    evsesPerState: this.vm().evsesPerState,
  }));

  public readonly RouteSegment = RouteSegment;
  protected readonly PermissionStoreModelEnum = PermissionStoreModelEnum;
}
